<template>
  <div class="page page-metro">
    <img class="page-banner" src="../../assets/banners/metro.jpg">
    <div class="page-header">
        <div>
            <h2><WFTranslate k="page-metro">Download the HSL app</WFTranslate></h2>
            <img class="page-image" src="../../assets/pages/hsl.png">
        </div>
        <WFTranslate k="page-metro-description"></WFTranslate>
    </div>
    <div class="page-description flex">
        <WFTranslate k="page-metro-description2"></WFTranslate>
        <button class="btn btn-border btn-lg" @click="showRoute('poi', 'metro')">
            <WFIcon name="path"></WFIcon>
            <WFTranslate k="show_path">Show route</WFTranslate>
        </button>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        page: {
			type: Object,
			default: null
		},
    },
    watch: {
        page () {
            console.log('page', this.page)
        }
    },
    mounted () {
        console.log('page2', this.page)
    },
    methods: {
        showRoute (type, slug) {
            this.$emit('showRoute', type, slug)
        },
        viewOnMap (type, slug) {
            this.$emit("viewOnMap", type, slug);
        }
    }
}
</script>

<style lang="less">
    .page-metro {
        .page-header {
            display: flex;
            flex-direction: column;

            & > div {
                display: flex;
                justify-content: space-between;
                
            }

            label {
                margin-top: 2.4rem;
            }
        }

        .btn {
            margin-left: 2rem;
        }
    }
</style>